module.exports = __webpack_public_path__ + "static/media/company-Ban.68b6ef7e.svg";